/**
 * @fileoverview Tooltip wrapper that matches the legacy bl-tooltip API.
 */

import React from 'react';

export interface TooltipProps {
  children: React.ReactNode;
  message?: string | null;
  position?: 'top' | 'bottom';
  styleType?: 'dark' | 'light';
}

const Tooltip: React.FC<TooltipProps> = ({
  children,
  message = '',
  position = 'top',
  styleType = 'dark',
}) => {
  const tooltipPositionClass = `bl_tooltip_${position}_${styleType}`;

  return (
    <div className={`bl-tooltip ${tooltipPositionClass}`} data-tooltip={message}>
      {children}
    </div>
  );
};

export default Tooltip;
